export const ProfilePanelPath = "u";
export const ManagementPanelPath = "o";
export const ProfileInfoPath = "info";
export const BillingPath = "billing";
export const ProjectsPath = "projects";
export const SingleProjectPath = "projects/:projectId";
